import { Flag, HStack, Heading } from "@project/ui";
import type { DriverFieldsFragment } from "@/components/contentful/driver/__generated/driver.contentful.generated";

type DriverUnderTitleComponentProps = DriverFieldsFragment;

export const DriverUnderTitleComponent = (props: DriverUnderTitleComponentProps) => {
    const { flag, country } = props;

    return (
        <HStack spacing={1} mt={2} mb={{ base: 6, l: 0 }}>
            {flag && (
                <>
                    <Flag mr={4} countryCode={flag} h={5} w={8} />
                    <Heading as="p" size="headingMedium" fontWeight="600">
                        {country}
                    </Heading>
                </>
            )}
        </HStack>
    );
};
